export default {"src":"/_next/static/media/graphics.32859dac.svg","height":347,"width":1440,"blurWidth":0,"blurHeight":0};